import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import PromptCard from './components/PromptCard';
import backgroundImage from '../../assets/images/gallaryBackground.png';

const BackgroundContainer = styled(Box)({
  width: '100%',
  height: '100%',
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
});
const BackgroundShadow = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.54)',
});

const Unexisting404Page = () => {
  return (
    <BackgroundContainer>
      <BackgroundShadow>
        <PromptCard />
      </BackgroundShadow>
    </BackgroundContainer>
  );
};

export default Unexisting404Page;
